<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4>{{ $t('availabilityIntervals.edit') }}</h4>
      <CButton color="secondary" @click="goBack">{{ $t('goBack') }}</CButton>
    </div>
    
    <AvailabilityIntervalsForm 
      :baseInterval="interval" 
      :baseIntervalName="intervalName"
      @submit-requested="onSubmitRequested" 
      :loading="loading">
    </AvailabilityIntervalsForm>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AvailabilityIntervalsForm from './AvailabilityIntervalsForm.vue';
import router from '@/router';

export default {
  components: { AvailabilityIntervalsForm },
  data() {
    return {
      loading: false,
      interval: null,
      intervalName: null
    };
  },
  computed: {
    ...mapState('availabilityIntervals', ['getAvailabilityIntervalByIdOutput']),
    ...mapState('availabilityIntervals', ['updateAvailabilityIntervalOutput', 'generateSlotsOutput'])
  },
  async mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loading = true;
      try {
        await this.getById(id);
      } catch (error) {
        console.error('Error loading interval:', error);
        this.$router.push({ name: 'AvailabilityIntervalsList' });
      } finally {
        this.loading = false;
      }
    } else {
      this.$router.push({ name: 'AvailabilityIntervalsList' });
    }
  },
  methods: {
    ...mapActions('availabilityIntervals', ['getById']),
    ...mapActions('availabilityIntervals', ['update', 'generateSlots']),
    async onSubmitRequested(interval) {
      this.loading = true;
      try {
        // Reset generateSlotsOutput before starting
        this.$store.commit('availabilityIntervals/setGenerateSlotsOutput', null);
        
        const result = await this.update(interval);
        // After successful update, automatically generate slots
        // Use interval.id as fallback since we know it exists in edit mode
        const intervalId = (result && result.id) ? result.id : interval.id;
        if (intervalId) {
          await this.generateSlots({ id: intervalId, regenerateExisting: true });
        } else {
          // If we can't get the id, set loading to false
          this.loading = false;
        }
      } catch (error) {
        console.error('Error updating interval:', error);
        this.loading = false;
      }
    },
    goBack() {
      router.push({ name: 'AvailabilityIntervalsList' });
    }
  },
  watch: {
    getAvailabilityIntervalByIdOutput(val) {
      if (val) {
        this.interval = val;
        this.intervalName = val.experience?.name || 'Interval';
      }
    },
    updateAvailabilityIntervalOutput(val) {
      if (val) {
        // Don't set loading to false here, wait for generateSlotsOutput
      }
    },
    generateSlotsOutput(val) {
      if (val) {
        this.loading = false;
        // The form component will handle showing the message via its own watcher
      }
    }
  }
};
</script>

